export class UnusualMile {
    accountId: string;
    accountNumber: string;
    ledger: string;
    enabled: boolean;
    email1: string;
    email2: string;
    email3: string;
    totalsByCard: boolean;
    checkType: string;
}

export class UnusualMileReportModel {
    UnusualMile: UnusualMile;
    EndPointURL: string;
    Token: string;
    AccountId: string;
}

export class UninvoicedDrawing {
    accountId: string;
    accountNumber: string;
    ledger: string;
    enabled: boolean;
    startDate: string;
    includeNonFuelItems: boolean;
    email1: string;
    email2: string;
    email3: string;
    showEstPrice: boolean;
    fileType: string;
    includeDateDrawn: boolean;
}

export class UninvoicedDrawing2 {
    accountId: string;
    accountNumber: string;
    startDate: string;
    includeNonFuel: boolean;
    includePrice: boolean;

    email: string;
    FirstName: string;
    LastName: string;
    ReportOption: number;
    DistributionChannel: number;

}

export class UninvoicedDrawingReportModel {
    UninvoicedDrawing: UninvoicedDrawing;
    EndPointURL: string;
    Token: string;
    AccountId: string;
}


export class CardMisusage {
    accountId: string;
    accountNumber: string;
    ledger: string;
    enabled: boolean;
    reportFrequency: string;
    excludeMultiVehicles: boolean;
    email1: string;
    email2: string;
    email3: string;
    dailyLitres: number;
    dailyTransactions: number;
    dailyValue: number;
    weeklyLitres: number;
    weeklyTransactions: number;
    weeklyValue: number;
}

export class CardMisusageReportModel {
    CardMisusage: CardMisusage;
    EndPointURL: string;
    Token: string;
    AccountId: string;
}

export class AutomatedDrawing {
    accountId: string;
    accountNumber: string;
    ledger: string;
    enabled: boolean;
    lastRunDate: string;
    reportingPeriod: string;
    email1: string;
    email2: string;
    email3: string;
}

export class AutomatedDrawingReportModel {
    AutomatedDrawing: AutomatedDrawing;
    EndPointURL: string;
    Token: string;
    AccountId: string;
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.ts